
const d = (obj) => obj && obj.__esModule ? obj.default : obj;

const allValues = obj => {
  const keys = Object.keys(obj);
  return Promise.all(keys.map(k => obj[k])).then(values => {
    const next = {};
    keys.forEach((k, i) => {
      next[k] = values[i];
    });
    return next;
  });
};


const SCOPE = {
"css": d(require('/Users/jquense/src/react-overlays/www/src/css.js')),
"styled": d(require('@emotion/styled')),
"injectCss": d(require('/Users/jquense/src/react-overlays/www/src/injectCss.js'))
};
const IMPORTS = {
'useDropdownMenu': () => allValues({
  "react-overlays": import(/* webpackChunkName: "docpoc-useDropdownMenu" */ '/Users/jquense/src/react-overlays/src/index.ts')
  }),
'useDropdownToggle': () => allValues({
  "react-overlays": import(/* webpackChunkName: "docpoc-useDropdownToggle" */ '/Users/jquense/src/react-overlays/src/index.ts')
  }),
'useRootClose': () => allValues({
  "react-overlays": import(/* webpackChunkName: "docpoc-useRootClose" */ '/Users/jquense/src/react-overlays/src/index.ts')
  }),
'Dropdown': () => allValues({
  "react-overlays": import(/* webpackChunkName: "docpoc-Dropdown" */ '/Users/jquense/src/react-overlays/src/index.ts')
  }),
'Overlay': () => allValues({
  "react-overlays": import(/* webpackChunkName: "docpoc-Overlay" */ '/Users/jquense/src/react-overlays/src/index.ts')
  }),
'Modal': () => allValues({
  "react-overlays": import(/* webpackChunkName: "docpoc-Modal" */ '/Users/jquense/src/react-overlays/src/index.ts')
  }),
'Portal': () => allValues({
  "react-overlays": import(/* webpackChunkName: "docpoc-Portal" */ '/Users/jquense/src/react-overlays/src/index.ts')
  }),
'/transitions': () => allValues({
  "react-overlays": import(/* webpackChunkName: "docpoc--transitions" */ '/Users/jquense/src/react-overlays/src/index.ts'),
"react-transition-group/Transition": import(/* webpackChunkName: "docpoc--transitions" */ '/Users/jquense/src/react-overlays/www/node_modules/react-transition-group/esm/Transition.js')
  }),
};
import React from 'react';

import ExamplesContext from './ExamplesContext';

// eslint-disable-next-line no-undef
const context = { imports: IMPORTS, scope: SCOPE };

export default ({ element }) => (
  <ExamplesContext.Provider value={context}>{element}</ExamplesContext.Provider>
);
